import { render, staticRenderFns } from "./regionTree.vue?vue&type=template&id=5b979812"
import script from "./regionTree.vue?vue&type=script&lang=js"
export * from "./regionTree.vue?vue&type=script&lang=js"
import style0 from "./regionTree.vue?vue&type=style&index=0&id=5b979812&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports